import { render, staticRenderFns } from "./insurance2.vue?vue&type=template&id=2f309c80&scoped=true"
import script from "./insurance2.vue?vue&type=script&lang=js"
export * from "./insurance2.vue?vue&type=script&lang=js"
import style0 from "./insurance2.vue?vue&type=style&index=0&id=2f309c80&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f309c80",
  null
  
)

export default component.exports